import React from 'react';
import ReactDOM from 'react-dom';
import registerServiceWorker from './registerServiceWorker';
import App from './App';
import LoadBar from './LoadBar';
import loadApp from './loadApp';
import './alt';
import {LoadAction} from './actions';

ReactDOM.render(<LoadBar />, document.getElementById('loader'));
loadApp()
  .then(() => {
    LoadAction.startApp.defer();

    ReactDOM.render(<App splash={false} />, document.getElementById('root'));
    return Promise.resolve();
  })
  .then(registerServiceWorker);
